import React from 'react';
import { paths } from 'config/path_helpers';
import fetch from 'utilities/fetch';
import style from './style.module.scss';

export default () => {
  const handleCancel = () => {
    return fetch(paths.api.userProfile(), {
      method: 'PATCH',
      body: JSON.stringify({ userProfile: { practiceTestDate: null } })
    }).then(() => {
      window.location.reload();
    });
  };

  return (
      <a onClick={handleCancel} className={style.topLink}>
        cancel
      </a>
  );
};
